import React from 'react';
import { Text } from '@blueprint/ui';
import { Container, Heading } from './GuidePrice.styles';

const TenancyInfo = () => {
    return (
        <Container data-testid="guide-price-container">
            <Heading isRegular size="3">
                Guide price
            </Heading>
            <Text>
                The “Guide Price” is an indication of the seller’s minimum
                acceptable price at auction. The guide price can be shown in the
                form of a minimum and maximum price range, or as a single price
                figure. This is subject to change up to and including the day of
                the auction and will not necessarily be the final selling price
                at auction.
            </Text>

            <Heading isRegular size="3">
                Reserve price
            </Heading>
            <Text>
                The “Reserve Price” is the seller’s minimum acceptable price at
                auction and the figure below which the auctioneer cannot sell.
                This is normally set within the guide price range or within 10%
                of a single guide price. The reserve price is not disclosed and
                is subject to change up to and including the day of the auction.
            </Text>
        </Container>
    );
};

export default TenancyInfo;
